module.exports = __webpack_public_path__ + "img/ca0e03f73629f0295c5c4416522a512d.png";